<section>
  <div *ngIf="visibleListDetail">
    <app-custom-table [headers]="detailHeader.columns" [data]="detailData" [checkBoxAction]="checkboxActions"
      [clearSelectionTrigger]="clearSelectionTrigger" [showCheckbox]="rowsEditable" [showRecover]="true"
      [listShowView]="listShowView" [showDeployBy]="showDeployBy" [previousFilters]="filters"
      (onFilterChange)="onFilterChange($event)" (onPageChange)="onPageChange($event)"
      (onRecoverData)="getInvoicingCutoffDetailsForRegisterTable()" (showDeployByEmit)="onShowDeployByChange($event)"
      (onAction)="onAction($event)">
    </app-custom-table>
  </div>
</section>